// Types
// Enums
// Utils
import{typedModal}from"../../utils/typedModals";const BundleCustomizationModalEvents=typedModal();export default BundleCustomizationModalEvents;